export default __webpack_public_path__ + "static/media/banner-1.4acc5d64.png";